import React, { useEffect, useState } from "react";
import useRefreshToken from "../../../../Hooks/usegenerateToken";
import { BASE_URL, GET_VERIFIER_REQUEST, USER_TOKEN } from "../../../../Utils/constant";
import SlideUpWrapper from "../../../../components/Transitions/SlideUpWrapper";
import TopTitleBar from "../TopTitleBar";
import { Debounce } from "../../../../Utils/helper";
import ShimmerLoader from "../../../../components/ShimmerLoader";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../components/Loader";

import API from '../../../../ApiConfig';
import cogoToast from "cogo-toast-react-17-fix";
const VerifierDocRequest = ({ ISSUER_ID }) => {
  useRefreshToken(BASE_URL + USER_TOKEN);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [ListData, setListData] = useState([]);
  const [currentRecords, setCurrentRecords] = useState([])
  useEffect(() => {

    getVerifierDocRequest()

  }, [])
  const getVerifierDocRequest = () => {
    setLoading(true);

    API.get(GET_VERIFIER_REQUEST + ISSUER_ID)
      .then(res => {
        if (res.data.status == 200) {
          setLoading(false)
          setListData(res.data.data)
          setCurrentRecords(res.data.data)
        }
      })
      .catch(err => {
        setLoading(false)
        // console.log(err);

      })
  }
  const navigate = useNavigate()
  function handleSearch(e) {
    setSearch(e);
    handleSearchFilter(e);
  }
  const handleSearchFilter = Debounce((value) => {
    let result = ListData.filter(
      (item) =>
        (item.notification_info_name.includes(value)) ||
        item.notification_info_email.includes(value) ||
        item.notification_info_phone_number.includes(value)
    );
    setCurrentRecords(result);
  }, 800);

  const handleNavigate=(holder_data)=>{
    const holderData={verifier_request_id:holder_data.id}
    navigate("/dashboard/credentials/issue-credentials", {state:{master_document_id:holder_data.master_document_id}})
    localStorage.setItem("holder_data",JSON.stringify(holderData))
  }
  return (
    <>
      <SlideUpWrapper>
        <TopTitleBar isChild>
          <h2 className="topTitleBarText">
            <span className="secondaryButton1">Verifier Document Requests</span>
          </h2>
        </TopTitleBar>
        <div>
          <section className="table-header6">
            <div className="inputField2">
              <div className="input1">
                <div className="content1">
                  <img
                    className="searchOutlineIcon1"
                    alt=""
                    src="/searchoutline.svg"
                  />
                  <input
                    value={search}
                    onChange={(e) => handleSearch(e.target.value)}
                    className="inputText1"
                    placeholder="Search"
                  />
                </div>
              </div>
            </div>
          </section>
          <Loader isOpen={loading} />
          <div className="credentials-table">
            <table style={{ borderRadius: "10px" }}>
              <tr className="credentials-header bg-lgray">
              <th className="credentials-th">
                  <div className="credentials-table-text">Emp ID</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Emp Name</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Emp Email</div>
                </th>

                <th className="credentials-th">
                  <div className="credentials-table-text">Emp Mobile</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Document Name</div>
                </th>
                <th className="credentials-th justify-content-center">
                  <div className="credentials-table-text">Actions</div>
                </th>

              </tr>
              {loading ? <>
                <tr className="credentials-tr" >
                  <td className="credentials-td">
                    <div className="credentials-table-text"> <ShimmerLoader width='10rem' height='1.5rem' /></div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text"><ShimmerLoader width='7rem' height='1.5rem' /></div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                  </td>
                </tr>
                <tr className="credentials-tr" >
                  <td className="credentials-td">
                    <div className="credentials-table-text"> <ShimmerLoader width='10rem' height='1.5rem' /></div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text"><ShimmerLoader width='7rem' height='1.5rem' /></div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                  </td>
                  <td className="credentials-td">
                    <div className="credentials-table-text"> <ShimmerLoader width='7rem' height='1.5rem' /></div>
                  </td>
                </tr>
              </> : currentRecords.length === 0 ?
                <tr className="credentials-tr">
                  <td colSpan="6" className="credentials-td text-center">
                    <div className="Data_List">No Document Request Found</div>
                  </td>
                </tr>
                :
                <>
                  {currentRecords.map((i, index) => {
                    return (
                      <tr className="credentials-tr" style={{ animationDelay: `${index * 0.1}s` }}>
                        <td className="credentials-td">
                          <div className="credentials-table-text1">{i.employee_id?i.employee_id:"NA"}</div>
                        </td>
                        <td className="credentials-td">
                          <div className="credentials-table-text1">{i.notification_info_name?i.notification_info_name:"NA"}</div>
                        </td>
                        <td className="credentials-td">
                          <div className="credentials-table-text1">{i.notification_info_email?i.notification_info_email:"NA"}</div>
                        </td>
                        <td className="credentials-td">
                          <div className="credentials-table-text1">{i.notification_info_phone_number?i.notification_info_phone_number:"NA"}</div>
                        </td>
                        <td className="credentials-td">
                          <div className="credentials-table-text1">{i.master_document_name}</div>
                        </td>
                        <td className="credentials-td Action-row">
                          <button className={i.status!==1?"btn btn-secondary":"btn btn-primary"} onClick={() => handleNavigate(i)} disabled={i.status!==1}>{i.status!==1?"Issued":"Issue"}</button>
                          {/* <button className={i.status!==1?"btn btn-secondary":"btn btn-primary"} onClick={()=>{}} disabled={i.status!==1} style={{whiteSpace:"nowrap"}}>Not an Employee</button> */}

                        </td>
                      </tr>)
                  })}
                </>}
            </table>
          </div >
          {/* <div style={{ margin: "10px" }}>
                        <Pagination
                            nPages={totalPages}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            onPageChange={handlePageChange}
                            loading={loading}
                        />
                    </div> */}
        </div>
      </SlideUpWrapper>
    </>
  );
};

export default VerifierDocRequest;
